module.exports = __webpack_public_path__ + "img/brasao-f8dc49123cf15674caf2936d57343231.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/brasao.png
// module id = 212
// module chunks = 1